import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Button, PageHeader } from '../../components/UI';
import {
  HiOutlineLink,
  HiOutlineCurrencyRupee,
  HiOutlineCreditCard,
  HiOutlineShieldCheck,
  HiOutlineMail,
  HiOutlineTicket,
} from 'react-icons/hi';

const FAQS = [
  {
    icon: HiOutlineLink,
    q: 'How does my referral link work?',
    a: "Share your referral link or code (both on your Dashboard) with businesses you know. When they register using it and pay for a plan, you earn commission automatically — no manual tracking needed.",
  },
  {
    icon: HiOutlineCurrencyRupee,
    q: 'When do I earn commission?',
    a: "Commission is credited the moment a business you referred completes a successful payment. It accrues whether or not your KYC is approved yet — only payouts are held until then.",
  },
  {
    icon: HiOutlineCreditCard,
    q: 'How and when do I get paid?',
    a: "Set your bank or UPI details in Settings. Payouts are released once your KYC is approved, either manually by our team or automatically if you're on an autopay schedule.",
  },
  {
    icon: HiOutlineShieldCheck,
    q: 'Why is my dashboard showing a KYC pending message?',
    a: "All self-signup partners go through a one-time KYC verification, usually completed within 1–2 business days. You'll get an email the moment it's approved.",
  },
];

const PartnerHelp = () => {
  const navigate = useNavigate();

  return (
    <div>
      <PageHeader title="Help" description="Common questions about referrals, commission, and payouts" />

      <div className="space-y-4 max-w-2xl mx-auto">
        {FAQS.map((f) => (
          <Card key={f.q}>
            <div className="flex gap-3">
              <div className="w-9 h-9 rounded-lg bg-primary-50 flex items-center justify-center flex-shrink-0">
                <f.icon className="w-4.5 h-4.5 text-primary-600" />
              </div>
              <div>
                <p className="font-semibold text-secondary-900 text-sm">{f.q}</p>
                <p className="text-sm text-secondary-500 mt-1">{f.a}</p>
              </div>
            </div>
          </Card>
        ))}

        <Card className="text-center">
          <p className="text-sm font-semibold text-secondary-900">Still need help?</p>
          <p className="text-sm text-secondary-500 mt-1 mb-4">
            Raise a support ticket and our team will get back to you.
          </p>
          <div className="flex items-center justify-center gap-3">
            <Button variant="primary" icon={<HiOutlineTicket className="w-4 h-4" />} onClick={() => navigate('/partner/support')}>
              Raise a Ticket
            </Button>
            <a
              href="mailto:support@televalley.in"
              className="inline-flex items-center gap-2 text-sm font-medium text-secondary-600 hover:text-primary-600"
            >
              <HiOutlineMail className="w-4 h-4" />
              Email Us
            </a>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default PartnerHelp;
